// @givmo/board — the hint beside a seat's first term (CBG-UX5-HINT; design stop design-268's §10,
// frames a1 and a2), on "Add a member" and on "Record a term" while the seat has no term.
//
// One quiet line under the term's dates, then "Where to find it": a DISCLOSURE that opens its four
// short lines inline, under the line, inside the dialog — never a popover past the dialog's edge or
// over its own help (the orchestrator's by-eye note on frame a2). The button carries `aria-expanded`
// and names the lines it shows (`aria-controls`); it follows the term's end in the tab order, and the
// lines, plain text, follow it. They hang from a leading rule, the house's mark for a dependent row.
// "Add a member" ends them with "Not at hand? Leave it blank…" (`later`); "Record a term", already on
// the person's page and recording at least one date, doesn't.

import { useId, useState } from 'react';
import { Icon, testIdProp } from '@givmo/design-system';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { termHintWords as th } from './term-hint-words';

const QUIET = 'font-sans text-s12 font-w400 leading-h15 tracking-givmo text-text-tertiary';
const LINE = 'font-sans text-s12 font-w400 leading-h15 tracking-givmo text-text-secondary';

export function TermHint({ testId, later = true }: { testId: string; later?: boolean }) {
  const [open, setOpen] = useState(false);
  const linesId = useId();
  const lines = later ? [...th.lines, th.later] : th.lines;
  return (
    <div className="-mt-8 flex flex-col gap-8" {...testIdProp(testId)}>
      <p className={QUIET}>
        {th.line}{' '}
        <button
          type="button"
          aria-expanded={open}
          aria-controls={linesId}
          onClick={() => setOpen((was) => !was)}
          className="inline-flex items-center gap-2 font-w600 text-brand-700 outline-none hover:underline focus-visible:underline"
          {...testIdProp(`${testId}-how`)}
        >
          {th.where}
          <Icon icon={open ? ChevronUp : ChevronDown} size={14} aria-hidden />
        </button>
      </p>
      <div
        id={linesId}
        hidden={!open}
        className="flex flex-col gap-6 border-l-2 border-border pl-12"
        {...testIdProp(`${testId}-lines`)}
      >
        {lines.map((line) => (
          <p key={line} className={LINE}>
            {line}
          </p>
        ))}
      </div>
    </div>
  );
}
